import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';

import {
  IActionSaveFileAttachmentParams,
  ActionSaveFileAttachmentNormalizer
} from './client';

const createActionSaveFileAttachmentActualNameBase = ({
  targetVar
}: {
  targetVar: string | null;
}): string => {
  if (!targetVar) {
    return '';
  }
  return `Сохранить в ${targetVar}`;
};

export const createActionSaveFileAttachmentActualName: ActualNameCreator<
  IActionSaveFileAttachmentParams
> = ({ params }) =>
  createActionSaveFileAttachmentActualNameBase({
    targetVar: params.targetVar.value
  });

export const normalizeActionSaveFileAttachment: ActionSaveFileAttachmentNormalizer =
  (raw, stores) => {
    return {
      ...normalizeCommonFields(raw, stores),
      actualName: (t) =>
        createActualBlockName({
          paramsName: createActionSaveFileAttachmentActualNameBase({
            targetVar: raw.params.target_var
          }),
          blockKind: raw.kind,
          blockName: raw.name,
          t,
          ...stores
        })
    };
  };
